export enum ChartType {
  fullView = 'MachineChartInFullView',
  donwtimeTask = 'MachineChartInDowntimeTask',
  finishPhase = 'MachineChartInFinishPhase',
  editSetup = 'MachineChartInEditSetup',
  splitDowntime = 'MachineChartInSplitDowntime',
  editDowntime = 'MachineChartInEditDowntime',
}
